/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentDto } from '../../models/document-dto';

export interface PreDocumentControllerFindByCenterChild$Params {
  centerChildId: string;
}

export function preDocumentControllerFindByCenterChild(http: HttpClient, rootUrl: string, params: PreDocumentControllerFindByCenterChild$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentDto>>> {
  const rb = new RequestBuilder(rootUrl, preDocumentControllerFindByCenterChild.PATH, 'get');
  if (params) {
    rb.query('centerChildId', params.centerChildId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DocumentDto>>;
    })
  );
}

preDocumentControllerFindByCenterChild.PATH = '/api/pre-document';
